import {ME, MY_MENUS} from './mutation-types';

export default {
  [ME](state, response) {
    state.userId = response.user.userId;
    state.userName = response.user.userName;
    state.companyName = response.user.companyName;
    state.email = response.user.email;
    state.phone1 = response.user.phone1;
    state.phone2 = response.user.phone2;
    state.phone3 = response.user.phone3;
    state.roleSeq = response.user.roleSeq;
    state.roleCode = response.role.roleCode;
    state.mainUrl = response.role.mainUrl;
    state.companySeq = response.user.companySeq;
  },
  [MY_MENUS](state, response) {
    state.myMenus = response.menus;
  }
};
